import LayoutScreen from '../../components/layout';
import iconArrowLeft from '../../assets/icon/icon_arrow_left.svg';
import iconCredit from '../../assets/icon/icon_credit.svg';
import Button from '../../components/button';
import ButtonLarge from '../../components/buttonLarge';

import { useNavigate } from 'react-router-dom';
import FormBuatProfile from './formBuatProfile';
import FormProfile from './formProfile';

const PageProfile = (props) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/'); // Programmatically navigate to /new-route
  };

  return (
    <LayoutScreen>
      <div className="relative flex flex-col flex-grow h-full px-5 p-5 xl:p-10">
        <div className="h-full flex flex-col flex-grow justify-between items-center">
          <div className=" w-full flex space-x-4 justify-between items-start">
            <div
              onClick={() => handleBack()}
              className="w-full cursor-pointer flex space-x-2 xl:space-x-4 justify-start items-center">
              <img
                src={iconArrowLeft}
                alt="icon arrow left"
                className="w-5 h-5 xl:w-8 xl:h-8 object-contain"
              />
              <div className=" w-full xl:text-2xl font-semibold text-textBlack">
                Profil
              </div>
            </div>
          </div>

          <div className="flex flex-grow w-full h-full py-5">
            <FormProfile />
          </div>
        </div>
      </div>
    </LayoutScreen>
  );
};

export default PageProfile;
